export default "__VITE_ASSET__BCAvi9Pi__"